// ZeiterfassungDashboardContext.ts
import React from 'react';

// Define proper interfaces for your data
export interface IUser {
  user_id: string;
  email?: string;
  fullname?: string;
  NameAbbreviation?: string;
  department?: string;
}

export interface IArbeitszeit {
  id: number;
  bvh: number;
  user_id: string;
  DATUM: string;
  BEGINN: string;
  ENDE: string;
  PAUSE: number;
  DAUER: number;
  BEARBEITER: string;
  KURZINFO?: string;
  NOTIZ?: string;
  TAETIGKEIT: string;
  gewdet?: string;
  GEWDET?: string;
  PROJEKTNR?: number;
  MANDNR?: number;
  BVH: string;
  bvh_uuid?: string;
}

export interface INote {
  id?: number;
  user_id: string;
  datum: string;
  notiz: string;
}

export interface IArbeitszeitenData {
  arbeitszeiten?: IArbeitszeit[];
  user_zeiterfassung?: IUser[];
  notes?: INote[];
  departments?: string[];
}

export interface IArbeitszeitenDay {
  date: Date;
  entries: IArbeitszeit[];
}

// Define a proper filter interface
export interface IFilter {
  department: string;
  user: string;
  bauvorhaben: string;
}

// Define action types for filter updates
export type FilterAction =
  | {type: 'SET_DEPARTMENT'; payload: string}
  | {type: 'SET_USER'; payload: string}
  | {type: 'SET_BAUVORHABEN'; payload: string}
  | {type: 'RESET_FILTERS'};

// Define the context interface
export interface IZeiterfassungDashboardContext {
  // Date selection
  selectedDateStart: Date;
  setSelectedDateStart: (date: Date) => void;
  selectedDateEnde: Date;
  setSelectedDateEnde: (date: Date) => void;

  // Data
  arbeitszeiten_alle_MA: IArbeitszeitenData;
  isLoading: boolean;

  // Filter state and actions
  filter: IFilter;
  dispatchFilter: React.Dispatch<FilterAction>;

  // Filter options (available choices for each filter)
  availableUsers: IUser[];
  availableBauvorhaben: string[];

  // Filtered data (for display)
  filteredData: IArbeitszeitenData;

  // Actions
  handle_Upadate_Arbeitszeiten_alle_MA: () => void;
  resetFilters: () => void;
}

// Create the context with a default value
const ZeiterfassungDashboardContext = React.createContext<IZeiterfassungDashboardContext>({
  selectedDateStart: new Date(),
  setSelectedDateStart: () => {},
  selectedDateEnde: new Date(),
  setSelectedDateEnde: () => {},
  arbeitszeiten_alle_MA: {},
  isLoading: false,
  filter: {department: '', user: '', bauvorhaben: ''},
  dispatchFilter: () => {},
  availableUsers: [],
  availableBauvorhaben: [],
  filteredData: {},
  handle_Upadate_Arbeitszeiten_alle_MA: () => {},
  resetFilters: () => {},
});

export default ZeiterfassungDashboardContext;
